module.exports = __webpack_public_path__ + "img/T1D_xh13.ab61689a.png";